import React from "react";
import { useNavigate } from "react-router-dom";

function BackHomeButton({ backState = null, className = "" }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backState) {
      navigate("/Old_Home", { state: backState });
    } else {
      navigate("/Old_Home");
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`
        inline-flex items-center gap-1.5 sm:gap-2
        px-3 py-1.5 sm:px-5 sm:py-2.5
        bg-gradient-to-r from-[#4F7DF3] to-[#5B8CFF]
        text-white text-xs sm:text-sm font-semibold
        rounded-lg sm:rounded-xl
        shadow-sm hover:shadow-md
        hover:scale-105 active:scale-95
        transition-all duration-200
        ${className}
      `}
    >
      <span className="text-[10px] sm:text-sm">🏠</span> 
      <span className="leading-none">Home</span>
    </button> 
  );
}

export default BackHomeButton;